'use strict';

exports.trackEvent = trackEvent;
exports.shouldDispatchToNative = shouldDispatchToNative;

var URL_PATTERN = /^\/?(.*?)(\.html?)?$/; // Strip optional leading slash and optional .htm suffix

var logError = function () {
    if (typeof window !== 'undefined' && window.console && window.console.error) {
        window.console.error.apply(console, arguments);
    }
};

function _getMobNativeApi() {
    if (typeof window !== 'undefined' && window.ZMOB_nativeAPI) {
        return window.ZMOB_nativeAPI;
    }
};

/**
 * Overrides the call to GA with a
 * call to the native iOS and android
 * tracking method
 *
 * @method trackEvent
 * @private
 * @param {object} config
 **/
function trackEvent(config, callback) {
    var category = _stripSlashes(config.category),
        action = _stripSlashes(config.action),
        label = _stripSlashes(config.label),
        value = parseInt(config.value),
        api,
        called;

    var mobNativeAPI = _getMobNativeApi();
    if (mobNativeAPI) {
        if (mobNativeAPI.trackUAWebviewEvent) {
            mobNativeAPI.trackUAWebviewEvent(category, action, label, value, JSON.stringify(config.dimensions));
            called = true;
        } else if (mobNativeAPI.trackWebviewEvent) {
            mobNativeAPI.trackWebviewEvent(category, action, label, value);
            called = true;
        }
    }

    if (typeof callback === 'function') {
        callback.call();
    }

    if (!called) {
        logError('There was no native method for trackEvent');
    }
};

/**
Removes '/' from analytics params (action, category, label).
Native analytics api uses '/' as a property delimeter. This ensures that arguments
passed to the native analytics api don't get borked due to the presence of a '/'.
See: HDP-5046
@method _stripSlashes
@param {String} field
@return field if it is a string.
@private
**/
function _stripSlashes(field) {
    if (typeof field !== 'string') {
        return;
    }

    return field.replace(/\//g,'-');
};

/**
 * Remove leading forward slash and .htm extension if it exists.
 * RE app doesn't handle this scenario well.
 *
 * @method _filterUrl
 * @private
 * @param {String} url
 **/
function _filterUrl(url) {
    if (typeof url !== 'string') {
        return;
    }
    url = url.replace(URL_PATTERN, '$1');

    return url;
};

/**
 * Determines if we should dispatch calls to the native api
 *
 * @method shouldDispatchToNative
 * @private
 */
function shouldDispatchToNative() {
    return !!_getMobNativeApi();
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/universal-analytics/lib/native-api.js
// module id = 615
// module chunks = 1